__turbopack_context__.v({
  "className": "montserrat_e5e3a604-module__DAKlwa__className",
});
